import { fetchVocabularyLevel } from "./vocabularyData";
import { kanaToRomaji } from "./kanaToRomaji";

type VocabularyWord = {
    word: string;
    reading?: string;
    meanings?: string[];
};

/**
 * Looks up the lesson term in the same on-demand vocabulary data used by the
 * vocabulary page.  This deliberately loads only enough JLPT data to find a
 * match, rather than putting a dictionary in every lesson bundle.
 */
export type SavedWordDetails = { meaning?: string; romaji?: string };

export async function lookupSavedWordDetails(text: string, reading?: string): Promise<SavedWordDetails> {
    for (const level of [5, 4, 3, 2, 1]) {
        try {
            const words = await fetchVocabularyLevel(level) as VocabularyWord[];
            const match = words.find((word) => word.word === text && (!reading || word.reading === reading))
                ?? words.find((word) => word.word === text);
            if (match) return {
                meaning: match.meanings?.slice(0, 3).join("; "),
                romaji: match.reading ? kanaToRomaji(match.reading) : undefined,
            };
        } catch {
            // A failed optional lookup must never prevent saving the lesson term.
        }
    }
    return reading ? { romaji: kanaToRomaji(reading) } : {};
}
